import React, { useEffect } from "react";

export default function Modal({ open, onClose, title, children, testId, wide = false, tint = "" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  const tintMap = { sun: "tint-sun", red: "tint-red", blue: "tint-blue", mint: "tint-green", green: "tint-green", pink: "tint-pink", orange: "tint-orange", brain: "tint-pink", heart: "tint-red", cyan: "tint-blue", plasma: "tint-pink" };
  const tintClass = tintMap[tint] || "";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 animate-fade-up" style={{ background: "rgba(14,18,48,0.55)", backdropFilter: "blur(8px)" }} onClick={onClose} data-testid={testId ? `${testId}-backdrop` : undefined}>
      <div className={`relative w-full ${wide ? "max-w-4xl" : "max-w-lg"} max-h-[90vh] overflow-y-auto card animate-pop-in ${tintClass}`} onClick={(e) => e.stopPropagation()} data-testid={testId}>
        <div className="flex items-start justify-between mb-4 gap-3">
          <h3 className="font-display text-2xl sm:text-3xl text-[var(--ink)] leading-tight">{title}</h3>
          <button onClick={onClose} data-testid={testId ? `${testId}-close` : "modal-close"} className="shrink-0 w-9 h-9 rounded-full bg-white border-2 border-[var(--ink)] flex items-center justify-center text-lg hover:bg-[var(--paper-2)] transition" style={{ boxShadow: "2px 2px 0 0 var(--ink)" }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}
